<ng-container *ngIf="course">
  <ng-container *ngIf="course.syllabus; let syllabus">

      <ng-container *ngIf="syllabus.mainTitleBackgroundImg; else NonMainTitleBackgorundImg">
        <div class="p-relative w-100 h-100" appFileDrop (fileOver)="onFileOver($event)" (fileDrop)="onFileDrop($event)">
          <div class="main-intro w-100 h-100"
               [ngStyle]="{'background':'url('+ syllabus.mainTitleBackgroundImg + ') top center no-repeat'}">
            <div class="background-cover-layer-black w-100 h-100">
              <div class="main-text text-center w-100 p-relative px-5">
                <h1>{{ course.name }}</h1>
                <form class="w-100 title-form" (ngSubmit)="onSubmit(syllabus)" (ngModelChange)="onSubmit(syllabus)">
                  <mat-form-field class="w-100">
                    <textarea rows="2" matInput [(ngModel)]="syllabus.subTitle" name="subTitle" (ngModelChange)="onSubmit(syllabus)"></textarea>
                  </mat-form-field>
                </form>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #NonMainTitleBackgorundImg>
        <div class="p-relative w-100" appFileDrop (fileOver)="onFileOver($event)" (fileDrop)="onFileDrop($event)">
          <div class="main-intro w-100 d-block" [ngClass]=AppConfig.theme>
              <div class="main-text colorBackground px-5">
                <h1>{{ course.name }}</h1>
                <form class="w-100 title-form" (ngSubmit)="onSubmit(syllabus)" (ngModelChange)="onSubmit(syllabus)">
                  <mat-form-field class="w-100">
                    <textarea rows="2" matInput [(ngModel)]="syllabus.subTitle" name="subTitle" (ngModelChange)="onSubmit(syllabus)"></textarea>
                  </mat-form-field>
                </form>
              </div>
            </div>
        </div>
      </ng-template>


    <ng-container>
      <div class="page-block-a">
        <h5>Introduce This Course</h5>
        <h1 class="mt-3 mb-5">What is Purpose?</h1>

        <div class="flex-container" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <img fxFlex="50%" fxFlex.sm="90%" fxFlex.xs="90%" src="/assets/syllabus/bracket.png" />
        </div>

        <h5 class="my-5">
          <form class="w-100 title-form" (ngSubmit)="onSubmit(syllabus)" (ngModelChange)="onSubmit(syllabus)">
            <mat-form-field class="w-100">
              <textarea class="text-center" rows="6" matInput [(ngModel)]="syllabus.purpose" name="content" (ngModelChange)="onSubmit(syllabus)"></textarea>
            </mat-form-field>
          </form>
        </h5>
        <div class="flex-container" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <img fxFlex="50%" fxFlex.sm="90%" fxFlex.xs="90%" src="/assets/syllabus/bracket-bottom.png" />
        </div>
      </div>
    </ng-container>

    <app-center-divider></app-center-divider>

  <ng-container>
      <div class="page-block-b w-100 my-3">
        <div class="margin-center w-80">
          <mat-form-field class="w-100">
            <input placeholder="제목을 입력해주세요." class="text-center" matInput [(ngModel)]="syllabus.advantageTitle" name="title" (ngModelChange)="onSubmit(syllabus)" />
          </mat-form-field>
        </div>
        <div class="flex-container my-5 py-5" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutWrap="wrap">

          <div class="p-2" fxFlex.lg="27%" fxFlex="27%" fxFlex.sm="80%">
            <mat-card>
              <app-syllabus-photo-choice-button [course]="course" [index]="1">
                <button class="float-left" mat-icon-button>
                  <mat-icon class="color-gray p-2" aria-label="uploadImg">cloud_upload</mat-icon>
                </button>
              </app-syllabus-photo-choice-button>

              <img mat-card-image [src]=syllabus.advantage1Img>
              <mat-card-content>
                <mat-form-field class="w-100">
                  <input matInput [(ngModel)]="syllabus.advantage1Title" name="content" (ngModelChange)="onSubmit(syllabus)" />
                </mat-form-field>
                <mat-form-field class="w-100">
                  <textarea rows="4" matInput [(ngModel)]="syllabus.advantage1Exp" name="content" (ngModelChange)="onSubmit(syllabus)"></textarea>
                </mat-form-field>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="p-2" fxFlex.lg="27%" fxFlex="27%" fxFlex.sm="80%">
            <mat-card>
              <app-syllabus-photo-choice-button [course]="course" [index]="2">
                <button class="float-left"  mat-icon-button>
                  <mat-icon class="color-gray p-2" aria-label="uploadImg">cloud_upload</mat-icon>
                </button>
              </app-syllabus-photo-choice-button>
              <img mat-card-image [src]=syllabus.advantage2Img>
              <mat-card-content>
                <mat-form-field class="w-100">
                  <input matInput [(ngModel)]="syllabus.advantage2Title" name="content" (ngModelChange)="onSubmit(syllabus)" />
                </mat-form-field>
                <mat-form-field class="w-100">
                  <textarea rows="4" matInput [(ngModel)]="syllabus.advantage2Exp" name="content" (ngModelChange)="onSubmit(syllabus)"></textarea>
                </mat-form-field>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="p-2" fxFlex.lg="27%" fxFlex="27%" fxFlex.sm="80%">
            <mat-card>
              <app-syllabus-photo-choice-button  [course]="course"[index]="3">
                <button class="float-left"  mat-icon-button>
                  <mat-icon class="color-gray p-2" aria-label="uploadImg">cloud_upload</mat-icon>
                </button>
              </app-syllabus-photo-choice-button>
              <img mat-card-image [src]=syllabus.advantage3Img>
              <mat-card-content>
                <mat-form-field class="w-100">
                  <input matInput [(ngModel)]="syllabus.advantage3Title" name="content" (ngModelChange)="onSubmit(syllabus)" />
                </mat-form-field>
                <mat-form-field class="w-100">
                  <textarea rows="4" matInput [(ngModel)]="syllabus.advantage3Exp" name="content" (ngModelChange)="onSubmit(syllabus)"></textarea>
                </mat-form-field>
              </mat-card-content>
            </mat-card>
          </div>

        </div>
      </div>
    </ng-container>

    <app-center-divider></app-center-divider>

    <ng-container>
      <div class="page-block-c my-5 px-3 pb-5 w-100">
        <h5 class="margin-center text-center">온/오프라인 피드백이 진행되는</h5>
        <h1 class="mt-3 pb-5 text-center">Curriculum</h1>
          <app-syllabus-curriculum-edit [course]="course" [courseObservable]="courseObservable"></app-syllabus-curriculum-edit>
      </div>
    </ng-container>

    <app-center-divider></app-center-divider>

    <ng-container>
      <div class="page-block-c my-5 px-3 pb-5 w-100">
        <h5 class="margin-center text-center" >꾸준한 피드백을 통해 변화하는</h5>
        <h1 class="mt-3 pb-5 text-center">강의방식</h1>

        <div class="flex-container" fxLayoutAlign="center center" fxLayout.xs="column" fxLayoutWrap="wrap">
          <div fxFlex.lg="80%" fxFlex.md="80%" fxFlex.sm="95%">
            <app-syllabus-curriculum-numbering-list-edit [course]="course" [courseObservable]="courseObservable"></app-syllabus-curriculum-numbering-list-edit>
          </div>
        </div>

      </div>
    </ng-container>

    <app-center-divider></app-center-divider>

    <ng-container>
      <div class="page-block-d w-100 mb-5 py-5">
        <h1 class="pb-5 mt-4 text-center px-5">
          <mat-form-field class="w-80">
            <input class="pt-3" matInput placeholder="타이틀을 입력해주세요" [(ngModel)]="syllabus.additionalTitle" name="content" (ngModelChange)="onSubmit(syllabus)" />
          </mat-form-field>
        </h1>
        <div class="flex-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <div class="block-d-card p-2" fxFlex="27%" fxFlex.sm="80%">
            <mat-card [ngClass]=AppConfig.theme>
              <mat-card-content>
                <mat-form-field class="w-100">
                 <input matInput [(ngModel)]="syllabus.addCard1Title" name="content" (ngModelChange)="onSubmit(syllabus)" />
                </mat-form-field>
                <mat-form-field class="w-100">
                 <textarea rows="3" matInput [(ngModel)]="syllabus.addCard1Exp" name="content" (ngModelChange)="onSubmit(syllabus)"></textarea>
                </mat-form-field>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="block-d-card p-2" fxFlex="27%" fxFlex.sm="80%">
            <mat-card [ngClass]=AppConfig.theme>
              <mat-card-content>
                <mat-form-field class="w-100">
                  <input matInput [(ngModel)]="syllabus.addCard2Title" name="content" (ngModelChange)="onSubmit(syllabus)" />
                </mat-form-field>
                <mat-form-field class="w-100">
                  <textarea rows="3" matInput [(ngModel)]="syllabus.addCard2Exp" name="content" (ngModelChange)="onSubmit(syllabus)"></textarea>
                </mat-form-field>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="block-d-card p-2" fxFlex="27%" fxFlex.sm="80%">
            <mat-card [ngClass]=AppConfig.theme>
              <mat-card-content>
                <mat-form-field class="w-100">
                  <input matInput [(ngModel)]="syllabus.addCard3Title" name="content" (ngModelChange)="onSubmit(syllabus)" />
                </mat-form-field>
                <mat-form-field class="w-100">
                  <textarea rows="3" matInput [(ngModel)]="syllabus.addCard3Exp" name="content" (ngModelChange)="onSubmit(syllabus)"></textarea>
                </mat-form-field>
              </mat-card-content>
            </mat-card>

          </div>
        </div>
      </div>
    </ng-container>

    <app-center-divider></app-center-divider>

    <ng-container>
      <div class="page-block-e py-5 mb-5">
        <h1 class="mt-2 mb-5 pb-5 px-5">
          <mat-form-field class="w-80">
            <input class="pt-3" matInput placeholder="타이틀을 입력해주세요" [(ngModel)]="syllabus.instructorMsgTitle" name="content" (ngModelChange)="onSubmit(syllabus)" />
          </mat-form-field>
        </h1>
        <div class="flex-container" fxLayout="row" fxLayout.xs="row" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <div class="block-quote" fxFlex="75%" fxFlex.sm="80%">
            <div class="block-icon img-circle">
              <i class="fa fa-quote-left" aria-hidden="true"></i>
            </div>
            <h3 class="block-profile">
              <input class="pt-3" class="text-left" matInput [(ngModel)]="syllabus.instructorName" name="content" (ngModelChange)="onSubmit(syllabus)" />
              <span>
                <input class="text-left instructor-position" matInput [(ngModel)]="syllabus.instructorPos" name="content" (ngModelChange)="onSubmit(syllabus)" />
              </span>
            </h3>
            <blockquote>
              <textarea rows="5" matInput [(ngModel)]="syllabus.instructorMsg" name="content" (ngModelChange)="onSubmit(syllabus)"></textarea>
            </blockquote>
          </div>
        </div>
      </div>
    </ng-container>

    <app-center-divider></app-center-divider>

    <ng-container>
      <div class="page-block-f py-5 mb-5">
        <h1 class="mt-2 mb-5 pb-5 px-5">이 강의를 먼저 수강한 분들이 추천합니다.</h1>
        <div class="flex-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <div fxFlex="75%" fxFlex.sm="90%" [ngClass]=AppConfig.theme>
            <app-syllabus-recommenders-edit [course]="course" [courseObservable]="courseObservable"></app-syllabus-recommenders-edit>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container>
      <div class="hook-block" [ngClass]=AppConfig.theme>
        <h2 class="text-center border-bottom-white">
          <input matInput class="instructor-position" [(ngModel)]="syllabus.hookMsg" name="content" (ngModelChange)="onSubmit(syllabus)" />
        </h2>
      </div>
    </ng-container>

    <ng-container>
      <div class="page-block-g mt-5 py-3">
        <mat-card class="apply-card w-80 margin-center mt-5 mb-5 p-5" [ngClass]=AppConfig.theme>
          <mat-card-content>
            <textarea rows="5" class="border-bottom-gray" matInput [(ngModel)]="syllabus.applyCard" name="comment" (ngModelChange)="onSubmit(syllabus)"></textarea>
          </mat-card-content>
          <mat-form-field class="w-100">
            <input matInput class="text-left" placeholder="수강신청을 위한 url을 입력해주세요 (https://부터 입력해주세요.)" [(ngModel)]="syllabus.applyUrl" name="appplyUrl" (ngModelChange)="onSubmit(syllabus)" >
          </mat-form-field>
        </mat-card>
      </div>
    </ng-container>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-edit/syllabus-edit.component.html